export enum TABLE_ALIGN {
  RIGHT = 'right',
  LEFT = 'left',
  CENTER = 'center',
}

export enum TABLE_ORDER {
  DESC = 'desc',
  ASC = 'asc',
  NONE = 'none',
}
